module.exports = __webpack_public_path__ + "static/media/partner-14.ed9fc17a.webp";